(() => {
	const videos = document.querySelectorAll('.wp-block-video, .wp-block-media-text__media');

	if(!videos) return;

	for(const video of videos) {
		const player = video.querySelector('video[controls]');
		if(!player) continue;

		player.removeAttribute('controls');

		const overlay = document.createElement('div');
		overlay.classList.add('overlay');

		overlay.addEventListener('click', () => {
			if(player.paused) {
				player.play();
				video.classList.add('playing');
			} else {
				player.pause();
				video.classList.remove('playing');
			}
		});

		player.addEventListener('ended', () => {
			player.currentTime = 0;
			video.classList.remove('playing')
		});

		video.append(overlay);
	}
})();